import {
  AccAddressType,
  AccBooleanValue,
  AccCariesActivity,
  AccCondition,
  AccGender,
  AccToothInjuryClassification,
  AccToothPreAccidentCondition,
  IAccClaim,
  IPatient,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { toISODate, WithRef } from '@principle-theorem/shared';
import { NameHelpers } from '../../patient/name-helpers';
import * as moment from 'moment-timezone';

export const ACC_SUCCESSFUL_TEST_SCENARIO = (
  practice: WithRef<IPractice>,
  patient: WithRef<IPatient>
): IAccClaim => ({
  pmsSoftwareName: 'Principle',
  pmsSoftwareVersion: '2.05',
  vendor: {
    practiceName: 'ACC Test Clinic',
    hpiOrganisationNumber: practice.accSettings?.vendorId ?? '',
    hpiFacilityNumber: '',
  },
  provider: {
    details: {
      providerId: practice.accSettings?.providerId ?? 'PPP285',
      providerTypeCode: '80',
      firstName: 'Test',
      middleName: '',
      surname: 'Provider',
    },
    address: {
      line1: '123 Fake Street',
      line2: '',
      suburb: '',
      city: 'Wellington',
      postCode: '6023',
      country: 'New Zealand',
      type: AccAddressType.Home,
    },
  },
  patient: {
    address: {
      line1: '100 Patient Place',
      line2: '',
      suburb: 'Kilbirnie',
      city: 'Wellington',
      postCode: '6021',
      country: 'New Zealand',
      type: AccAddressType.Home,
    },
    occupationCode: '9993',
    contact: {
      emailAddress: '',
      homePhone: '',
      mobilePhone: '',
      workPhone: '',
    },
    details: {
      nhi: '',
      otherEthnicity: '',
      firstName: NameHelpers.firstName(patient.name),
      middleName: '',
      surname: NameHelpers.lastName(patient.name),
      dateOfBirth: '1945-03-27',
      gender: AccGender.Male,
      ethnicityCode: '21',
    },
  },
  employment: {
    inPaidEmployment: AccBooleanValue.False,
    employmentStatusCode: '',
    otherEmployment: '',
    workTypeCode: '',
  },
  injury: {
    accidentDate: '2017-11-20',
    injuryComments: '',
    accidentLocationCode: '347',
    accidentSceneCode: '10',
    causeOfAccident: 'Tripped over dog, hurt right knee',
    involvesVehicle: AccBooleanValue.False,
    medicalTreatmentInjury: AccBooleanValue.False,
    workInjury: AccBooleanValue.False,
    sportingInjury: AccBooleanValue.False,
  },
  dentalDiagnosis: {
    prosthesis: {
      wornAtTimeOfInjury: AccBooleanValue.False,
    },
    other: {
      permanentTeethMissingPriorToAccident: AccBooleanValue.False,
      oralHygiene: AccCondition.Good,
      periodontalCondition: AccCondition.Good,
      cariesActivityInMouth: AccCariesActivity.Extensive,
      radiographsTaken: AccBooleanValue.False,
      photographicRecordOfInjury: AccBooleanValue.False,
    },
    teeth: {
      injuries: [
        {
          toothNumber: 11,
          injuryClassification: [AccToothInjuryClassification.Avulsion],
          preAccidentCondition: [AccToothPreAccidentCondition.HeavilyRestored],
        },
      ],
    },
  },
  workCapacity: {
    canResumeNormalWork: AccBooleanValue.True,
  },
  declaration: {
    providerDeclaration: toISODate(moment()),
  },
});
